let product_card= document.querySelectorAll('.featured_product_card');
    if(product_card){
      function updateProductCardImageHeight() {
        product_card.forEach((card) => {
          let image_div = card.querySelector('.best_seller_product_image ');
          let scroll_div = card.querySelector('.product_grid_item_marquee_block ');
          if (!image_div || !scroll_div) return;
          let imageHeight = image_div.offsetHeight ;
          let scroll_divHeight = scroll_div.offsetHeight ;
          const finalHeight = imageHeight - scroll_divHeight;
          scroll_div.closest('.group-block').style.setProperty('--image-height', `${finalHeight}px `);
        });
      }
      window.addEventListener('load', updateProductCardImageHeight);
      window.addEventListener('resize', updateProductCardImageHeight);
    }
    const colorBlocks = document.querySelectorAll('.color_group_block');
    colorBlocks.forEach((block, index) => {
      block.setAttribute('data-index', index + 1);
    });
    const imageBlocks = document.querySelectorAll('.product_images_group_block > .group-block > .product_grid_images');
    imageBlocks.forEach((block, index) => {
      block.setAttribute('data-index', index + 1);
    });
    const ColorBlocks = document.querySelectorAll('.color_group_block');
    const ProductImages = document.querySelectorAll('.product_grid_images');
    ColorBlocks.forEach(block => {
      block.addEventListener('click', () => {
        const index = block.getAttribute('data-index');
        ColorBlocks.forEach(b => b.classList.remove('active'));
        ProductImages.forEach(img => img.classList.remove('active'));
        block.classList.add('active');
        ProductImages.forEach(img => {
          if (img.getAttribute('data-index') === index) {
            img.classList.add('active');
          }
        });
      });
    });

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.read--button');
  if (!btn) return;
  const targetDetails = document.querySelector(
    'details[data-label-title="Description"]'
  );
  if (targetDetails) {
    targetDetails.open = true;
    targetDetails.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    setTimeout(() => {
      window.scrollBy({
        top: -50,
        behavior: 'smooth'
      });
    }, 300);
  }
});

(function () {
  'use strict';

  function hydrateVideo(video) {
    if (!video) return;

    video.querySelectorAll('source[data-sourcesrc]').forEach(source => {
      const newSrc = source.dataset.sourcesrc;
      if (newSrc && source.getAttribute('src') !== newSrc) {
        source.setAttribute('src', newSrc);
      }
    });

    try { video.load(); } catch (e) {}

    if (
      video.hasAttribute('autoplay') ||
      video.hasAttribute('data-video-autoplay') ||
      video.dataset.videoAutoplay === 'true'
    ) {
      video.muted = true;
      video.playsInline = true;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    video.dataset.hydrated = '1';
  }

  function primeExisting() {
    document.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('video[data-video-type="native"]')) {
            hydrateVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
          }
        });
      }
    });
  });

  function startAll() {
    primeExisting();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }


    if (document.querySelector('source[data-sourcesrc]')) {
        window.addEventListener('mousemove', startAll, { once: true, passive: true });
        window.addEventListener('touchstart', startAll, { once: true, passive: true });
    }
})();

/*
 * Deferred-image loader (generic, per-image)
 * ------------------------------------------
 * Pairs with the `lazy: true` branch in snippets/resource-image.liquid and the
 * scoped lazy mode in blocks/image.liquid. Each server-rendered <img> that
 * opts in arrives as:
 *
 *   <img class="… lazy-image"
 *        src="<1×1 transparent GIF>"
 *        data-src="https://cdn.shopify.com/.../image_240x.jpg"
 *        data-srcset="<responsive srcset>"
 *        sizes="…"
 *        loading="lazy">
 *
 * On intersection (with `rootMargin: '400px 0px'` so loading starts BEFORE
 * the image scrolls into view) we copy data-src → src and data-srcset → srcset,
 * which triggers the browser's image fetch. One-shot per image: unobserve
 * after hydration.
 *
 * Previously this observed parent sections (one entry per section). Now we
 * observe each lazy <img> individually — strictly more accurate (an image
 * far down inside a tall section no longer prematurely hydrates) and removes
 * the need to maintain a list of "lazy-eligible" section selectors here.
 * Coverage is decided server-side by the Liquid; the JS just hydrates whatever
 * arrives flagged.
 *
 * Eligible sources today:
 *   • Collection cards (blocks/_collection-card-image.liquid → resource-image)
 *   • Blog post cards (blocks/_featured-blog-posts-image.liquid → resource-image)
 *   • Generic image blocks (blocks/image.liquid) inside `section`,
 *     `collection-list`, `product-list`, or `featured-blog-posts` parent sections.
 *
 * Browsers without IntersectionObserver hydrate everything immediately.
 *
 * Idempotent via `window.__lazyImagesBound` + per-<img> `data-hydrated` /
 * `data-lazy-observed` flags, so MutationObserver firings can't double-process.
 */
(function () {
  'use strict';
  // Window-level guard; cast through any since the property isn't on the typed
  // Window interface (this is plain JS and the IDE infers strict types).
  if (/** @type {any} */ (window).__lazyImagesBound) return;
  /** @type {any} */ (window).__lazyImagesBound = true;

  var LAZY_IMG_SELECTOR = 'img.lazy-image[data-src]';

  /** @param {HTMLImageElement} img */
  function hydrateImage(img) {
    if (!img || img.dataset.hydrated === '1') return;
    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }
    img.classList.remove('lazy-image');
    img.dataset.hydrated = '1';
  }

  // Fallback for browsers without IntersectionObserver — hydrate immediately.
  if (!('IntersectionObserver' in window)) {
    /** @type {NodeListOf<HTMLImageElement>} */
    (document.querySelectorAll(LAZY_IMG_SELECTOR)).forEach(hydrateImage);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      hydrateImage(/** @type {HTMLImageElement} */ (entry.target));
      io.unobserve(entry.target);
    });
  }, {
    // Start loading when the image is ~400px below the viewport — gives the
    // browser a head start so bytes are decoded by the time the user scrolls
    // the image into actual view. For images already in/near the viewport at
    // page-load, this fires immediately (no waiting).
    rootMargin: '400px 0px',
    threshold: 0
  });

  /** @param {ParentNode | Document | null} [root] */
  function observeAll(root) {
    /** @type {NodeListOf<HTMLImageElement>} */
    var imgs = (root || document).querySelectorAll(LAZY_IMG_SELECTOR);
    imgs.forEach(function (/** @type {HTMLImageElement} */ img) {
      if (img.dataset.lazyObserved === '1') return;
      img.dataset.lazyObserved = '1';
      io.observe(img);
    });
  }

  // Initial pass.
  observeAll(document);

  // Late-arriving images (Section Rendering API re-renders, theme editor,
  // dynamically-injected content, etc.).
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!(node instanceof HTMLElement)) continue;
          if (node.matches && node.matches(LAZY_IMG_SELECTOR)) {
            if (node.dataset.lazyObserved !== '1') {
              node.dataset.lazyObserved = '1';
              io.observe(node);
            }
          } else if (node.querySelectorAll) {
            observeAll(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/*
 * `body.hide-initially` removal on first user interaction
 * -------------------------------------------------------
 * The body ships with `class="hide-initially …"` (see layout/theme.liquid:48)
 * which assets/custom.css uses to hide the UserWay accessibility widget
 * (`.hide-initially .userway_buttons_wrapper { display: none !important; }`)
 * until the user actually engages with the page. This avoids the widget
 * flashing in during initial paint and lets its (heavy) script load behind
 * the user's first interaction instead of blocking initial render.
 *
 * On the FIRST of any of these events — scroll, click, keydown, touchstart,
 * mousemove, pointerdown — we drop the class so the widget (and anything else
 * gated by `.hide-initially …` rules in future) becomes visible.
 *
 * Listeners are `{ once: true, passive: true }` so they auto-detach after
 * firing and never block scroll / touch performance. The `removed` flag is
 * a belt-and-braces guard in case two events fire in the same tick.
 *
 * Idempotent via `window.__hideInitiallyBound`.
 */
(function () {
  'use strict';
  if (/** @type {any} */ (window).__hideInitiallyBound) return;
  /** @type {any} */ (window).__hideInitiallyBound = true;

  var body = document.body;
  if (!body || !body.classList.contains('hide-initially')) return;

  var removed = false;
  function unhide() {
    if (removed) return;
    removed = true;
    body.classList.remove('hide-initially');
  }

  var events = ['scroll', 'click', 'keydown', 'touchstart', 'mousemove', 'pointerdown'];
  events.forEach(function (evt) {
    window.addEventListener(evt, unhide, { once: true, passive: true });
  });
})();

/*
 * Marquee seamless-loop content duplicator
 * ----------------------------------------
 * Paired with the `@keyframes scroll` animation (translates by -50%) and the
 * `.product_grid_item_marquee_block.group-block-content { display: inline-flex;
 * width: max-content; }` layout rules in assets/custom.css.
 *
 * Server emits one copy of the merchant text inside each marquee group block:
 *
 *   <div class="product_grid_item_marquee_block group-block-content">
 *     <rte-formatter ...><p>Free Shipping on Orders Over $50</p></rte-formatter>
 *   </div>
 *
 * The -50% translate keyframe only produces a gap-free loop when there are
 * TWO identical copies tiled side-by-side — so this script clones each existing
 * child once and appends the clone with `aria-hidden="true"` (no double
 * announcement by screen readers) and any `id=` attributes stripped (so the
 * doubled DOM remains valid).
 *
 * Idempotent — `data-marquee-duplicated="1"` on the container prevents
 * re-cloning, and `window.__marqueeDuplicateBound` prevents re-binding the
 * MutationObserver if custom.js runs twice for any reason.
 */
(function () {
  'use strict';
  if (/** @type {any} */ (window).__marqueeDuplicateBound) return;
  /** @type {any} */ (window).__marqueeDuplicateBound = true;

  var SELECTOR = '.product_grid_item_marquee_block.group-block-content';

  /**
   * Clone the marquee's children enough times that the total marquee width
   * always covers the parent viewport during the full animation cycle.
   *
   * Two-copy default (the previous behaviour) is fine for parents narrower
   * than one tile — but on wider product cards the second copy's right edge
   * passes the right edge of the viewport mid-cycle, exposing empty space
   * (the "text disappears then reappears" the user reported). The fix:
   * measure parent vs. one-tile width and clone `ceil(parent / tile) + 1`
   * times so the marquee is always at least `parent + tile` wide.
   *
   * Translate amount is then set to `-(100 / N)%` via the `--marquee-end`
   * custom property — that equals exactly ONE tile width in pixels
   * regardless of N, so the animation duration of 10s ÷ one-tile-of-pixels
   * gives identical scroll speed across every card.
   */
  // Hard cap on how many copies we'll ever clone into a single marquee.
  // Even the widest realistic card (~1200px) with a narrow tile (~150px)
  // needs at most ~9 copies for continuous coverage. Any number larger
  // than this is a measurement glitch (tile or parent reported wrong
  // during a view-transition snapshot, hidden parent, sub-pixel layout,
  // etc.) — clamp so a single bad read can't blow up into thousands of
  // appendChild calls and freeze the main thread. Pre-fix, an `offsetWidth`
  // of 1px on a 1500px parent computed copiesNeeded = 1501, which
  // synchronously cloned 1500 nodes per marquee. That's the page-freeze.
  var MAX_COPIES = 8;
  // Minimum plausible tile width in pixels. Below this we treat the
  // measurement as not-yet-laid-out and defer to the next frame instead
  // of acting on a bogus number.
  var MIN_PLAUSIBLE_PX = 20;

  /*
   * Perf restructure (OPT-12, 2026-07-24)
   * -------------------------------------
   * The previous implementation processed each marquee synchronously at
   * script evaluation: read offsetWidth → appendChild clones → next marquee
   * read → forced full-document re-layout. With ~dozens of card marquees and
   * a 6,700-element DOM that interleaving cost ~3.1 s of forced reflow inside
   * the mobile LCP window (trace-verified).
   *
   * Now: marquees are initialized lazily via IntersectionObserver (within
   * 200px of the viewport) and processed in per-frame batches with a strict
   * READ phase (all measurements, zero writes → one layout for the whole
   * batch) followed by a WRITE phase (all clones/appends/style vars).
   * The per-marquee OUTPUT is unchanged: same copy math, same --marquee-end,
   * same aria-hidden clones with ids stripped, same idempotency flag.
   * The paused-animation CSS rule in custom.css keeps pre-init marquees as
   * static text, so nothing scrolls with a gap while waiting.
   */

  /** @type {HTMLElement[]} */
  var pending = [];
  var scheduled = false;

  /** @param {HTMLElement} el */
  function enqueue(el) {
    if (!el || el.dataset.marqueeDuplicated === '1' || el.dataset.marqueeQueued === '1') return;
    el.dataset.marqueeQueued = '1';
    pending.push(el);
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(processBatch);
    }
  }

  function processBatch() {
    scheduled = false;
    var batch = pending;
    pending = [];

    /** @type {{ el: HTMLElement, children: Element[], copies: number }[]} */
    var jobs = [];

    // READ phase — measure every queued marquee with no interleaved DOM
    // writes, so the entire batch costs a single layout pass.
    for (var i = 0; i < batch.length; i++) {
      var el = batch[i];
      if (!el) continue;
      delete el.dataset.marqueeQueued;
      if (el.dataset.marqueeDuplicated === '1') continue;

      var children = Array.from(el.children);
      if (!children.length) continue;

      var parent = el.parentElement;
      if (!parent) continue;

      // With one set of children, `el.offsetWidth` equals the natural width
      // of a single tile (including the trailing margin-inline-end).
      var tileWidth = el.offsetWidth;
      var parentWidth = parent.offsetWidth;

      // Implausibly small → layout not committed yet (view transition,
      // just-inserted node). Re-queue for the next frame — same retry
      // semantics as before, but batched.
      if (tileWidth < MIN_PLAUSIBLE_PX || parentWidth < MIN_PLAUSIBLE_PX) {
        enqueue(el);
        continue;
      }

      // Copies needed for full viewport coverage at max translate, clamped
      // to MAX_COPIES so a measurement glitch can't explode.
      var copies = Math.max(2, Math.ceil(parentWidth / tileWidth) + 1);
      copies = Math.min(copies, MAX_COPIES);
      jobs.push({ el: el, children: children, copies: copies });
    }

    // WRITE phase — all clones/appends/style writes together, no reads.
    for (var j = 0; j < jobs.length; j++) {
      var job = jobs[j];
      for (var c = 0; c < job.copies - 1; c++) {
        job.children.forEach(function (/** @type {Element} */ child) {
          var clone = /** @type {HTMLElement} */ (child.cloneNode(true));
          clone.setAttribute('aria-hidden', 'true');
          // Strip ids on and inside the clone so the doubled DOM stays
          // spec-valid (no duplicate-id violations).
          if (clone.id) clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach(function (/** @type {Element} */ idEl) {
            idEl.removeAttribute('id');
          });
          job.el.appendChild(clone);
        });
      }
      // Pin the keyframe end translate to exactly one tile width. With N
      // copies the total marquee width is N × tile, and -(100/N)% of that
      // equals -1 × tile in pixels — the seamless-loop translation amount.
      job.el.style.setProperty('--marquee-end', '-' + (100 / job.copies) + '%');
      job.el.dataset.marqueeDuplicated = '1';
    }
  }

  // Initialize each marquee only when it approaches the viewport. This keeps
  // all marquee work off the LCP critical path and also fixes a pre-existing
  // edge case: hidden marquees no longer spin an endless rAF retry loop —
  // they simply initialize when they become visible/intersecting.
  /** @type {IntersectionObserver | null} */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry || !entry.isIntersecting) continue;
        var target = /** @type {HTMLElement} */ (entry.target);
        if (io) io.unobserve(target);
        enqueue(target);
      }
    }, { rootMargin: '200px 0px' });
  }

  /** @param {HTMLElement} el */
  function watch(el) {
    if (!el || el.dataset.marqueeDuplicated === '1') return;
    if (io) {
      io.observe(el);
    } else {
      // No IntersectionObserver support → process directly (old behaviour).
      enqueue(el);
    }
  }

  /** @param {ParentNode | Document | null} [root] */
  function primeAll(root) {
    /** @type {NodeListOf<HTMLElement>} */
    var els = (root || document).querySelectorAll(SELECTOR);
    els.forEach(watch);
  }

  // Initial pass.
  primeAll();

  // Late-arriving marquees (SRA re-renders, theme editor edits, etc.).
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m) continue;
        var added = m.addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!(node instanceof HTMLElement)) continue;
          // `node.matches` is always defined on HTMLElement — calling directly.
          if (node.matches(SELECTOR)) {
            watch(node);
          } else {
            primeAll(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();